import { render, staticRenderFns } from "./certificationBody.vue?vue&type=template&id=756b8534&scoped=true&"
import script from "./certificationBody.vue?vue&type=script&lang=js&"
export * from "./certificationBody.vue?vue&type=script&lang=js&"
import style0 from "./certificationBody.vue?vue&type=style&index=0&id=756b8534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756b8534",
  null
  
)

export default component.exports